module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<li class=\"active\"><a id=\"groupCommon\" name=\"common\" data-toggle=\"tab\" href=\"#common\">Common</a></li>\r\n<li class=\"\"><a id=\"groupInput\" name=\"input\" data-toggle=\"tab\" href=\"#input\">Input</a></li>\r\n<li class=\"\"><a id=\"groupButtons\" name=\"buttons\" data-toggle=\"tab\" href=\"#buttons\">Buttons</a></li>\r\n<li class=\"\"><a id=\"groupLayout\" name=\"layout\" data-toggle=\"tab\" href=\"#layout\">Layout</a></li>\r\n<li class=\"\"><a id=\"groupContainers\" name=\"containers\" data-toggle=\"tab\" href=\"#containers\">Containers</a></li>\r\n<li class=\"\"><a id=\"groupAssets\" name=\"assets\" data-toggle=\"tab\" href=\"#assets\">Images</a></li>\r\n<li class=\"\"><a id=\"groupAll\" name=\"all\" data-toggle=\"tab\" href=\"#all\">All</a></li>")
  }
  return __output;

}